import breakpoint from '@carvana/helios-layout/breakpoint';
import { text } from '@carvana/helios-styles';
import body from '@carvana/helios-typography/body';
import heading from '@carvana/helios-typography/heading';
import label from '@carvana/helios-typography/label';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import styled from 'styled-components';

const CheckmarkCircle = dynamic(() =>
  import('@carvana/helios-icons/CheckmarkCircleFilled').then(module => module.CheckmarkCircleFilled)
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CarImage = styled(Image as any)`
  height: 100%;
  width: 360px;
  margin: 0 auto;

  ${breakpoint.sm`
    width: 284px
  `}

  ${breakpoint.md`
    min-width: 400px;
    width: 40%;
  `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 24px;

  ${breakpoint.sm`
    flex-direction: row;
    justify-content: space-between;
    padding-top: 40px;
    padding-bottom: 40px;
    max-width: 100%;
  `}

  ${breakpoint.md`
    padding-top: 65px;
    padding-bottom: 56px;
  `}
`;

const Title = styled.h2`
  ${heading['2Xl']}
  color: ${text.strong};
  margin-top: 40px;
  margin-bottom: 24px;
  text-transform: none;

  ${breakpoint.sm`
    margin-top: 0px;
  `}

  ${breakpoint.md`
    ${heading['3Xl']}
  `}
`;

const Info = styled.p`
  ${body.lg}
  color: ${text.default};
  margin-bottom: 24px;
`;

const LineItem = styled.h4`
  ${label.lg}
  color: ${text.strong};
  display: inline;
  margin-left: 16px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StyledCheckmark = styled(CheckmarkCircle as any)`
  display: inline;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const TextContent = styled.div`
  ${breakpoint.sm`
    min-width: 280px;
  `}

  ${breakpoint.md`
    min-width: 505px;
  `}
`;

export { CarImage, Container, Title, Info, LineItem, StyledCheckmark, Row, TextContent };
